
import { Navigate } from 'react-router-dom'
import { deleteToken } from '../../Utilities/auth/auth'

export const Logout = () => {

    deleteToken()

    window.location.href="/login"
}